'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();let _performActionWithCleanupAndEatErrors=function(){var ref=_asyncToGenerator(





































































































function*(asyncToastAction,cleanup){
try{
yield asyncToastAction();
}catch(err){

}finally{
cleanup();
}
});return function _performActionWithCleanupAndEatErrors(asyncToastAction,cleanup){return ref.apply(this,arguments)}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}const _=require('pulsar-utils/dist-es6/_');const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let ConnectionStatusMonitorDirective=function(_BaseControllerBacked){_inherits(ConnectionStatusMonitorDirective,_BaseControllerBacked);function ConnectionStatusMonitorDirective(){_classCallCheck(this,ConnectionStatusMonitorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ConnectionStatusMonitorDirective,[{key:'optionalObjectBindings',get:function(){return['enabled']}},{key:'controller',get:function(){return ConnectionStatusMonitorDirectiveController}}]);return ConnectionStatusMonitorDirective}(BaseControllerBackedDirective);const ControllerDefaults={enabled:!0,_initiallyConnected:!1,_toast:null,_showingDisconnectionToast:!1,_showingReconnectionToast:!1};let ConnectionStatusMonitorDirectiveController=function(){function ConnectionStatusMonitorDirectiveController($scope,$timeout,$mdToast,socketService){var _this2=this;_classCallCheck(this,ConnectionStatusMonitorDirectiveController);this._$scope=$scope;this._$timeout=$timeout;this._$mdToast=$mdToast;this._socketService=socketService;_.defaults(this,ControllerDefaults);this._reconnectedToast=$mdToast.simple().textContent('Reconnected!').hideDelay(1000).position('bottom left');this._disconnectedToast=$mdToast.simple().textContent('Disconnected from server, attempting to reconnect...').hideDelay(0).position('bottom left');const debouncedUpdateConnectionStatus=_.debounce(function(){return _this2._socketService.isConnected?_this2._displayReconnectedToast():_this2._displayDisconnectionToast()},1000);this._$timeout(function(){_this2._$scope.$watch('controller._socketService.isConnected',function(isConnected,wasConnected){if(!_this2.enabled){return}if(!_this2._initiallyConnected){_this2._initiallyConnected=isConnected;if(isConnected){return}}if(wasConnected&&isConnected===wasConnected){return}debouncedUpdateConnectionStatus()})},2000)}ConnectionStatusMonitorDirectiveController.prototype._displayDisconnectionToast=function(){var ref=_asyncToGenerator(function*(){var _this3=this;if(this._showingDisconnectionToast){return}this._showingDisconnectionToast=!0;yield _performActionWithCleanupAndEatErrors(function(){return _this3._$mdToast.show(_this3._disconnectedToast)},function(){return _this3._showingDisconnectionToast=!1})});function _displayDisconnectionToast(){return ref.apply(this,arguments)}return _displayDisconnectionToast}();ConnectionStatusMonitorDirectiveController.prototype._displayReconnectedToast=function(){var ref=_asyncToGenerator(function*(){var _this4=this;if(this._showingReconnectionToast){return}this._showingReconnectionToast=!0;if(this._showingDisconnectionToast){yield _performActionWithCleanupAndEatErrors(function(){return _this4._$mdToast.hide(_this4._disconnectedToast)},function(){return _this4._showingDisconnectionToast=!1})}yield _performActionWithCleanupAndEatErrors(function(){return _this4._$mdToast.show(_this4._reconnectedToast)},function(){return _this4._showingReconnectionToast=!1})});function _displayReconnectedToast(){return ref.apply(this,arguments)}return _displayReconnectedToast}();return ConnectionStatusMonitorDirectiveController}();

module.exports=ConnectionStatusMonitorDirective;
//# sourceMappingURL=connectionStatusMonitorDirective.js.map
